export default {
    url: '',
    template: '<forms-forms-form-general form="vm.form" form-model="vm.formModel" sites="vm.sites"></forms-forms-form-general>',
    resolve: {
        formModel (FormResource, $stateParams) {
            return FormResource.get({ id: $stateParams.id, expand: 'formI18ns,category,author,tags,sites' }).$promise;
        },
        sites (SiteResource) {
            return SiteResource.query({ formSites: true }).$promise;
        }
    },
    controller (formModel, sites, FormFactory, FormResource) {
        this.formModel = formModel;
        this.sites = sites;
        this.form = FormFactory.create(new FormResource, model => model.$update({ id: model.id, expand: 'formI18ns,category,author,tags' }));

        this.form.model = angular.copy(this.formModel);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/forms/form/general/index.js